
import React, { useState, useEffect, useContext, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX, faArrowsRotate, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure } from "@nextui-org/react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import RequestPdf from './RequestPdf';
import { Toast } from 'primereact/toast';
import { motion } from 'framer-motion'
import "../StaffPanel.css"
import DocViewerComp from './DocVIewer/DocViewerComp';
import FormComponent from '../../components/FormComponents/FormComponent';
import axios from 'axios';
import BackEndUrl from '../../backURL';
import * as Yup from 'yup';
import { StaffContext } from '../Services/staff.context';
import { useFormik } from 'formik';
import { w3cwebsocket as W3CWebSocket } from "websocket";
import moment from 'moment-timezone';
const backend_ = BackEndUrl.domain;
const modified_backend_Url = backend_.replace(/^https:\/\//, '');
const client = new W3CWebSocket('wss://'+modified_backend_Url);
client.onopen = () => {};

export default function DataListAccepted({ setselectedReq }) {
  const backend = BackEndUrl.domain;
  const toast = useRef(null);
  const [data, setData] = useState(null);
  const [dataSorted, setDataSorted] = useState(null);
  const [alteredData,SetAlternateData] = useState();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nic: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    id:{ value: null, matchMode: FilterMatchMode.STARTS_WITH },
    policy_number:{ value: null, matchMode: FilterMatchMode.STARTS_WITH },
    req_type:{ value: null, matchMode: FilterMatchMode.STARTS_WITH },

  });
  const [loading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const [selectedDataRow, SetSelectedDataRow] = useState(null);

  const [isRMOpen, setRMOpen] = useState(false)
  const acceptedRequests = useContext(StaffContext).acceptedRequests
  const GetAcceptedReqs = useContext(StaffContext).getAcceptedReq

  const formatDate = (dateString) => {
    // Parse the date string in UTC
    const utcDate = moment.utc(dateString);
  
    // Convert to Asia/Colombo timezone but keep the same time
    const colomboDate = utcDate.tz('Asia/Colombo', true);
  
    // Format the date
    return colomboDate.format('YYYY-MM-DD HH:mm:ss');
  };


  useEffect(() => {

    const formattedData = acceptedRequests && acceptedRequests.map((value) => {

      return {
        "id": value.req_id,
        "table_id": value.table_id,
        "policy_number":value.policy_details_policy_number,
        "name": value.full_name,
        "nic": value.nic,
        "mobile": value.mobile,
        "email": value.email,
        "table_name": value.table_name,
        "req_full_name": value.req_full_name,
        "req_nic": value.req_nic,
        "req_relationship": value.req_relationship,
        "req_birthday": value.req_birthday,
        "type_of_req": value.type_of_req,
        "proof_doc_alt": value.proof_doc,
        "proof_doc_birthday": value.proof_doc_birthday,
        "proof_doc_fullname": value.proof_doc_fullname,
        "proof_doc_nic": value.proof_doc_nic,
        "proof_doc_relationship": value.proof_doc_relationship,
        "percentage": value.percentage,
        "req_type": value.type_of_req,
        "old_data": value.old_data,
        "new_data": value.new_data,
        "nominee_name": value.nominee_name,
        "nominee_nic": value.nominee_nic,
        "nominee_relationship": value.nominee_relationship,
        "req_created_time": formatDate(value.req_created_time),
      };
    });

    // Sort by req_created_time
    const sortedRequstedData = formattedData.sort((a, b) => {
      return new Date(b.req_created_time) - new Date(a.req_created_time);
    });
    setDataSorted(sortedRequstedData);
    // Sort by req_created_time


    if (formattedData) {

      setData(formattedData);
      setLoading(false);
    }
  }, [acceptedRequests]);




  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  async function alteredDataLoad(req_id){
    try {
     const response = await axios.post(backend + "/alteration_data_load", {
       req_id: req_id,
      
 
     }, {
       headers: {
         Authorization: sessionStorage.getItem('staff-token'),
       }
     });
     SetAlternateData(response.data);
 
 
    }catch(err){
 
    }
 
 
   }


  const renderDetailsColumn = (rowData) => {

    return (
      <Button style={{backgroundColor:"#FF9843"}} variant="faded" onPress={onOpen} onClick={() => { SetSelectedDataRow(rowData)  ;alteredDataLoad(rowData?.id)}}>

        Details
      </Button>

    );
  };
  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" style={{ padding: "5px", margin: "5px" }} />
        </span>
      </div>
    );
  };


  const renderRefreshbtn = () => {
    return (
      <div style={{ paddingLeft: "1.5vw", paddingRight: "1.5vw" }}>
        <Button onClick={() => { GetAcceptedReqs() }}>
          <FontAwesomeIcon icon={faArrowsRotate} />
        </Button>
        
      </div>
    )

  }
  const Refreshbtn = renderRefreshbtn();

  const header = renderHeader();

async function  onComplete(req_id,req_mobile){
  {
    

    try {
   const response = await axios.post(backend + "/change-response", {
     req_id: req_id,
     type: "complete",
     reason: "Alternation Completed",
     staff_nic: sessionStorage.getItem("nic"),
     mobile: req_mobile     
    //  mobile: sessionStorage.getItem("mobile")
   }, {
     headers: {
       Authorization: sessionStorage.getItem('staff-token'),
     }
   })
   if (response.status == 200) {
     
    client.send(JSON.stringify({
      type: "message",
      msg: "status changed",
      
    }));
     onClose()
     GetAcceptedReqs();
    
     
     
   }
 }
 catch (err) {
   console.log(err)

 }






}
}


  return (

    <div className="card" >
      <>
        <Modal isOpen={isOpen} onOpenChange={onOpenChange} size={"5xl"} >
          <ModalContent style={{ height: "80vh" }} className='modal-scroll-bar'  >
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-col gap-1" style={{ backgroundColor: "#F7941E", fontSize: "1.7rem", color: "white" }}>Request Details</ModalHeader>
                <ModalBody className=' modal-overflow'    >

                  <p>
                    <b> Full Name  :    </b>      {selectedDataRow && selectedDataRow?.name}
                  </p>
                  <p>
                    <b> NIC :  </b>           {selectedDataRow && selectedDataRow?.nic}
                  </p>
                 
                  <p>
                    <b> Mobile  :     </b>       {selectedDataRow && selectedDataRow?.mobile}
                  </p>

                  {selectedDataRow && selectedDataRow.type_of_req == "add_data" ?
                    <>
                      <h1 style={{ fontSize: "1.4rem", textAlign: "center", color: "#13B1F1" }}>Adding New  {selectedDataRow && (
                        selectedDataRow.table_name === "policy_details" ? (
                          <span>Policy</span>
                        ) : (
                          <span>{selectedDataRow.table_name}</span>
                        )
                      )}</h1>
                      <h3 style={{ fontSize: "1.2.5rem", color: "#F7941E" }}>New {selectedDataRow && (
                        selectedDataRow.table_name === "policy_details" ? (
                          <span>Policy</span>
                        ) : (
                          <span>{selectedDataRow.table_name}</span>
                        )
                      )} info    :</h3>

                      <Row className='d-flex justify-content-center my-4'>
                        <Col xs={10} >
                          <Row>

                            <Col xs={6} >
                              <p className='my-3'><b>Name  :  </b> {selectedDataRow && selectedDataRow.req_full_name} </p>
                              <p className='my-3'><b>NIC  :   </b> {selectedDataRow && selectedDataRow.req_nic} </p>




                            </Col>
                            <Col xs={6}>

                              <p className='my-3'><b>Relationship  :   </b> {selectedDataRow && selectedDataRow.req_relationship} </p>
                              <p className='my-3'><b>Birthday  :    </b> {selectedDataRow && selectedDataRow.req_birthday} </p>
                              {selectedDataRow.table_name == "nominee"&& <p className='my-3'><b>Percentage  :    </b> {selectedDataRow && selectedDataRow.percentage} </p>}
                            </Col>
                          </Row>
                        </Col>
                      </Row>


                      <div className=' justify-content-center'>
                        {
                          <DocViewerComp selectedDataRow={selectedDataRow} />
                        }

                      </div>

                      <Row>
                        <Col xs={12}>

                        </Col>

                      </Row>

                    </>
                    : null}
                  {selectedDataRow && selectedDataRow.type_of_req == "alteration_data" ?
                    <>
                      <h1 style={{ fontSize: "1.4rem", textAlign: "center", color: "#13B1F1" }}>Altering  {selectedDataRow && (
                        selectedDataRow.table_name === "policy_details" ? (
                          <span>Policy</span>
                        ) : (
                          <span>{selectedDataRow.table_name}</span>
                        )
                      )} Details</h1>
                      <h3 style={{ fontSize: "1.2.5rem", color: "#F7941E" }}>Altering  {selectedDataRow && selectedDataRow.req_type} info    :</h3>

                      <Row className='d-flex justify-content-center my-4'>
                        <Col xs={10} >
                          <Row>
                          {alteredData?.map((val)=>{
                              return(
                                <>
                                <Col xs={12}>
                                <p  style={{  textAlign:"left", color: "#1188b8",fontWeight:"bold" }}>{val?.req_type} Change</p>
                              </Col>
                              {
                                    val.req_type == "percentage" &&
                                    <>
                                      <Col xs={6} >
                                        <p className='my-3'><b>Nominee Name   :  </b> {selectedDataRow?.nominee_name} </p>

                                      </Col>
                                      <Col xs={6} >
                                        <p className='my-3'><b>Nominee Nic    :  </b> {selectedDataRow?.nominee_nic}</p>

                                      </Col>
                                      <Col xs={12} >
                                        <p className='my-3'><b>Nominee Relationship   :  </b> {selectedDataRow?.nominee_relationship} </p>

                                      </Col>
                                    </>}
                              <Col xs={6} >
                              <p className='my-3'><b>Old   {val?.req_type} :  </b> {val?.old_data} </p>

                            </Col>
                            <Col xs={6}>

                              <p className='my-3'><b>New  {val?.req_type}  :   </b> {val?.new_data} </p>
                            </Col>
                            <Col xs={6}>

                                    <p className='my-3'><b>Proof Description :   </b> {val?.req_prof_description} </p>
                                  </Col>
</>
                              )

                              })}
                          </Row>
                        </Col>
                      </Row>


                      <DocViewerComp selectedDataRow={selectedDataRow} />


                      <Row>
                        <Col xs={12}>

                        </Col>

                      </Row>

                    </>
                    : null}

                </ModalBody>
                <ModalFooter>



                  <RequestPdf data={selectedDataRow} />
                  <Button color="success" style={{ color: "white" }} onPress={() => { onComplete(selectedDataRow.id,selectedDataRow.mobile) }}>
                    Completed
                  </Button>


                 
                </ModalFooter>
              </>
            )}
          </ModalContent>
        </Modal>


        <Row className='justify-content-start d-flex' style={{ width: "100%" }}>

          <Col xs={1} className='my-3 justify-content-start d-flex mx-3'>
            <motion.div
              whileTap={{
                scale: 0.9
              }}
              onClick={() => { setselectedReq(null) }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              
            </motion.div>
            
          </Col>
          <Col xs={10} className='justify-content-center '>
          <h1 style={{fontSize:"20px", fontWeight:"bold" ,textAlign:"center",marginTop:"20px", marginBottom:"20px"}}>ACCEPTED REQUEST</h1>
          </Col>
        </Row>
        <DataTable value={dataSorted} paginator rows={5} dataKey="id" filters={filters} filterDisplay="row" loading={loading}
          globalFilterFields={['name', 'nic', 'mobile', 'email', 'id']} header={header} emptyMessage="No requests found." stripedRows style={{ padding: "15px", backgroundColor: "#F9FAFB" }}>
         <Column body={renderDetailsColumn} header={Refreshbtn} style={{ textAlign: 'center', width: '15px' }} />
         <Column field="id" header="Request ID" filter filterPlaceholder="Search by request ID"  />
          <Column field="policy_number" header="Policy number" filter filterPlaceholder="Search by Policy number"  />
          <Column field="req_type" body={(rowData) => rowData.type_of_req === "alteration_data" ? (rowData.table_name === "policy_details" ? "Policy Details Change" : `${rowData.table_name} Change`) : `${rowData.table_name} add`} header="Type" filter  filterPlaceholder="Search by type"  />
          <Column field="name" header="Name" filter filterPlaceholder="Search by name"  />
          <Column field="nic" header="NIC" filter filterPlaceholder="Search by nic"  />
          <Column field="mobile" header="Contact Number" filter filterPlaceholder="Search by conatct number"  />
          <Column field="req_created_time" body="" header="Requested Date" style={{ minWidth: '12rem' }} />
          
        </DataTable>
      </>
    </div>
  );
}
